/**
 * Strip markdown formatting from text for use in plain-text previews.
 * Removes headers, bold/italic markers, links, images, and other markdown syntax.
 * 
 * @param {string} text - Raw markdown text
 * @returns {string} Plain text without markdown formatting
 */
export function stripMarkdown(text) {
    if (!text) return '';
    return text
        // Remove markdown headers (# ## ### etc.)
        .replace(/^#{1,6}\s+/gm, '')
        // Remove bold/italic markers
        .replace(/\*{1,3}(.*?)\*{1,3}/g, '$1')
        .replace(/_{1,3}(.*?)_{1,3}/g, '$1')
        // Remove strikethrough
        .replace(/~~(.*?)~~/g, '$1')
        // Remove inline code
        .replace(/`([^`]+)`/g, '$1')
        // Remove images
        .replace(/!\[.*?\]\(.*?\)/g, '')
        // Remove links but keep text
        .replace(/\[([^\]]+)\]\(.*?\)/g, '$1')
        // Remove blockquotes
        .replace(/^>\s+/gm, '')
        // Remove horizontal rules
        .replace(/^[-*_]{3,}\s*$/gm, '')
        // Remove list markers
        .replace(/^[\s]*[-*+]\s+/gm, '')
        .replace(/^[\s]*\d+\.\s+/gm, '')
        // Collapse multiple newlines
        .replace(/\n{2,}/g, ' ')
        // Collapse multiple spaces
        .replace(/\s{2,}/g, ' ')
        .trim();
}
